module.exports = __webpack_public_path__ + "static/img/icono_repetiraudio.074d2de8.svg";